// src/App.js
import React, { useState, useEffect } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";
import { getToken } from "./api";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(!!getToken());

  useEffect(() => {
    if (getToken()) setLoggedIn(true);
  }, []);

  return (
    <div>
      {loggedIn ? <Dashboard /> : <Login onLogin={() => setLoggedIn(true)} />}
    </div>
  );
}